export default __webpack_public_path__ + "static/mountains-9c4ef9ae5f508e9de7bb1851d7015bbf.png";